'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a message area in a menu
 *
 * @param {String} [options.target=.js-sitemenu__right]
 * @param {String} [options.fields.message='Started']
 * @param {String} [options.fields.type='normal']
 * @class
 */

class TabSubnavUserMessage extends Core {

    _defaults() {
        return {
            target: '.js-sitemenu__middle',
            fields: {
                'message': '',
                'type': 'normal'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__tab__subnav__message float">
                <div class='editor__tab__subnav__message__warning js-editor__tab__subnav__message__warning js-editor__tab__subnav__message'><%- message %></div>
                <div class='editor__tab__subnav__message__error js-editor__tab__subnav__message__error js-editor__tab__subnav__message'><%- message %></div>
                <div class='editor__tab__subnav__message__normal js-editor__tab__subnav__message__normal js-editor__tab__subnav__message'><%- message %></div>
            </div>
        `;

        super.render();
    }

    /**
     * Set the message menu to a certain value
     * @param {String} message - The message message
     * @param {String} [type="normal"] - The type of message,
     *                        can be "normal", "warning" or "error"
     * @returns none
     */

    setMessage(message, type) {
        this.show();
        
        $(".js-editor__tab__subnav__message__normal", this.$el).hide();
        $(".js-editor__tab__subnav__message__warning", this.$el).hide();
        $(".js-editor__tab__subnav__message__error", this.$el).hide();

        if(type == "error"){
            $(".js-editor__tab__subnav__message__error", this.$el).show();
        }else if(type == "warning"){
            $(".js-editor__tab__subnav__message__warning", this.$el).show();
        }else{
            $(".js-editor__tab__subnav__message__normal", this.$el).show();
        }

        $(".js-editor__tab__subnav__message", this.$el).html(message);
    }

    show(){
        $(this.$el).show();
    }

    hide(){
        $(this.$el).hide();
    }

    clear(){
        $(this.$el).hide();
    }
}
module.exports = TabSubnavUserMessage;
